var _polygon;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStEustaquio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.72 383.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.3 0 0 127.98 20.73 225.94 87.23 274.56 122.26 363.22 223.08 383.95 294.58 351.78 323.18 305.3 315.31 245.96 140.14 125.84 143.71 71.5 91.52 68.64 55.05 11.44 14.3 0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStEustaquio);
export default __webpack_public_path__ + "static/media/stEustaquio.f224d31b0c4fa91ff504dc4fe6ce09ef.svg";
export { ForwardRef as ReactComponent };